export const API_ROOT = 'https://www.reddit.com';

export const getSubredditPosts = async (subreddit) => {
  const response = await fetch(`${API_ROOT}${subreddit}.json`);
  //const response = await fetch(`${API_ROOT}/r/cat.json`);

  const json = await response.json();

  return json.data.children.map((post) => post.data);
};

export const getSubreddits = async () => {
  //const response = await fetch(`${API_ROOT}/subreddits.json`);
  const response = await fetch(`${API_ROOT}/subreddits/search.json?q=cat+OR+cats&limit=25&sort=new`); //only show subreddits containing the word "cats"
  //const response = await fetch(`https://www.reddit.com/subreddits/search.json?q=cats`);
  //const response = await fetch(`https://www.reddit.com/subreddits/search.json?q=subreddits_by_topic`);
  const json = await response.json();

  return json.data.children.map((subreddit) => subreddit.data);
};

export const getPostComments = async (permalink) => {
  const response = await fetch(`${API_ROOT}${permalink}.json`);
  const json = await response.json();

  return json[1].data.children.map((subreddit) => subreddit.data);
};
